module.exports = __webpack_public_path__ + "static/media/settings.a80cca85.png";